import {
  EXERCISE_TEMPLATE_LIST_REQUEST, EXERCISE_TEMPLATE_LIST_SUCCESS, EXERCISE_TEMPLATE_LIST_FAIL,
  EXERCISE_TEMPLATE_CREATE_SUCCESS, EXERCISE_TEMPLATE_UPDATE_SUCCESS, EXERCISE_TEMPLATE_DELETE_SUCCESS,
    EXERCISE_TEMPLATE_DETAILS_REQUEST,EXERCISE_TEMPLATE_DETAILS_SUCCESS,EXERCISE_TEMPLATE_DETAILS_FAIL,
  EXERCISE_TEMPLATE_RESET,
} from '../actions/types';

const initialState = {
  templates: [],
  templateDetails: null,
  loadingDetails: false,
  loading: false,
  success: false,
  error: null
};

export const exerciseTemplateReducer = (state = initialState, action) => {
  switch (action.type) {
    case EXERCISE_TEMPLATE_LIST_REQUEST:
      return { ...state, loading: true };
    case EXERCISE_TEMPLATE_LIST_SUCCESS:
      return { ...state, loading: false, templates: action.payload };
    case EXERCISE_TEMPLATE_CREATE_SUCCESS:
    case EXERCISE_TEMPLATE_UPDATE_SUCCESS:
      return { ...state, loading: false, success: true };
    case EXERCISE_TEMPLATE_DELETE_SUCCESS:
      return { ...state, loading: false, templates: state.templates.filter(t => t.id !== action.payload) };
    case EXERCISE_TEMPLATE_LIST_FAIL:
      return { ...state, loading: false, error: action.payload };
    case EXERCISE_TEMPLATE_RESET:
      return { ...state, success: false, error: null };
  //   case EXERCISE_TEMPLATE_DETAILS_REQUEST:
  // return { ...state, loadingDetails: true };
// case EXERCISE_TEMPLATE_DETAILS_SUCCESS:
  return { ...state, loadingDetails: false, templateDetails: action.payload };
case EXERCISE_TEMPLATE_DETAILS_REQUEST:
  return { 
    ...state, 
    loadingDetails: true, 
    templateDetails: null // Reset purana data
  };

case EXERCISE_TEMPLATE_DETAILS_SUCCESS:
  return {
    ...state,
    loadingDetails: false,
    templateDetails: action.payload,
  };

case EXERCISE_TEMPLATE_DETAILS_FAIL:
  return { 
    ...state, 
    loadingDetails: false, 
    error: action.payload 
  };
    default:
      return state;
  }
};